export default {
  computed: {
    getLabelTypeStreet () {
      return type => {
        switch (type) {
          case 1:
            return 'clientAddress.typesStreet.street'
          case 2:
            return 'clientAddress.typesStreet.prospectus'
          case 3:
            return 'clientAddress.typesStreet.boulevard'
          case 4:
            return 'clientAddress.typesStreet.square'
          case 5:
            return 'clientAddress.typesStreet.maidan'
          case 6:
            return 'clientAddress.typesStreet.lane'
          case 7:
            return 'clientAddress.typesStreet.alley'
          case 8:
            return 'clientAddress.typesStreet.highway'
          case 9:
            return 'clientAddress.typesStreet.trunk'
          case 10:
            return 'clientAddress.typesStreet.pickUp'
          case 11:
            return 'clientAddress.typesStreet.nameAddress'
          default:
            return 3.5
        }
      }
    }
  }
}

